import * as React from 'react';
import Project from 'src/entities/Project';
import './UpdateProject.css';
import { Link } from 'react-router-dom';
import ProjectUpdateTabsComponent from 'src/modules/project/update/partials/ProjectUpdateTabs.component';
import ProjectContactInformationFormContainer
  from 'src/modules/project/update/partials/ProjectContactInformationForm.container';
import ProjectCompanyFormContainer from 'src/modules/project/update/partials/ProjectCompanyForm.container';
import ProjectRoundInformationFormContainer
  from 'src/modules/project/update/partials/ProjectRoundInformationForm.container';

export interface ProjectUpdateComponentProps {
  project: Project;
  projectSection: string;
  handleClick(value: string): void;
  handleSubmit(): void;
}

class ProjectUpdateComponent extends React.PureComponent<ProjectUpdateComponentProps> {

  public render(): React.ReactNode {
    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <h1 className="bold-title">
                {this.props.project.company.name}
              </h1>
              <div className="gap-20"/>
            </div>
            <div className="col-md-4">
              <div className="gap-20"/>
              <p className="text-right">
                <Link to={'/ficha-de-operaciones/' + this.props.project.id} className="btn btn-primary-color">
                  Ir a la página de la operación
                </Link>
              </p>
            </div>
          </div>
          <div className="row padding-left-20">
            <p className="text-right">
              <Link to="/mi-empresa/">
                <span className="close"/>
              </Link>
            </p>
            <h3 className="bold-subtitle">
              Edición de la operación
            </h3>
          </div>
          <div className="gap-20"/>
          <ProjectUpdateTabsComponent projectSection={this.props.projectSection} handleClick={this.props.handleClick}/>
          <div className="row">
            <div className="col-sm-12 padding-l-r-0">
              <div className="tab-shadow-control">
                {this.renderForm(this.props.projectSection)}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  private renderForm(section: string): React.ReactNode {
    switch (section) {
      case 'contact':
        return (
          <ProjectContactInformationFormContainer
            project={this.props.project}
          />
        );
      case 'company':
        return (
          <ProjectCompanyFormContainer
            project={this.props.project}
          />
        );
      case 'round':
        return (
          <ProjectRoundInformationFormContainer
            project={this.props.project}
          />
        );
      default:
        return null;
    }
  }

}

export default ProjectUpdateComponent;



// WEBPACK FOOTER //
// ./src/modules/project/update/ProjectUpdate.component.tsx